module.exports = "<p *ngIf=\"isSplash\">\n    splash screen for 4 seconds !\n</p>"